import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "filter-edit-pane-container" }
const _hoisted_2 = { class: "font-weight-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.localSelectedFilter.FilterName), 1),
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        class: "btn btn-secondary valign",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.EditFilter && _ctx.EditFilter(...args)))
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("Button.Edit")), 1)
      ])
    ])
  ]))
}